var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFt04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 62,
    viewBox: "0 0 66 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8369 39.7128H54.8446C57.4304 39.7128 59.664 37.9817 60.2764 35.5032L65.9544 12.5204C66.0709 12.0488 65.9615 11.5506 65.6575 11.1687C65.3536 10.787 64.8888 10.5641 64.3967 10.5641H12.1314L9.87474 1.21479C9.70266 0.502362 9.05749 -0.000488281 8.31506 -0.000488281H1.60324C0.71785 -0.000488281 0 0.707588 0 1.58122C0 2.45484 0.71785 3.16292 1.60324 3.16292H7.04877L15.1175 36.592C12.0404 36.9449 9.64387 39.5305 9.64387 42.6594C9.64387 46.0284 12.422 48.7692 15.8369 48.7692H16.4172C13.9113 49.8151 12.1485 52.2652 12.1485 55.1141C12.1485 58.9108 15.2794 61.9995 19.1278 61.9995C22.9763 61.9995 26.1071 58.9107 26.1071 55.1141C26.1071 52.2653 24.3444 49.8151 21.8385 48.7692H52.5714C50.0655 49.8151 48.3027 52.2652 48.3027 55.1141C48.3027 58.9108 51.4336 61.9995 55.282 61.9995C59.1305 61.9995 62.2613 58.9107 62.2613 55.1141C62.2613 52.2653 60.4986 49.8151 57.9927 48.7692H60.2848C61.1702 48.7692 61.888 48.061 61.888 47.1875C61.888 46.314 61.1702 45.6058 60.2848 45.6058H15.8369C14.1901 45.6058 12.8503 44.284 12.8503 42.6594C12.8503 41.0347 14.19 39.7128 15.8369 39.7128ZM62.3558 13.7276L57.1612 34.7541C56.8958 35.8279 55.9649 36.5494 54.8448 36.5494H18.4034L12.895 13.7275L62.3558 13.7276ZM19.1278 58.8361C17.0475 58.8361 15.355 57.1664 15.355 55.1141C15.355 53.0618 17.0475 51.3921 19.1278 51.3921C21.2082 51.3921 22.9006 53.0618 22.9006 55.1141C22.9006 57.1664 21.2082 58.8361 19.1278 58.8361ZM55.282 58.8361C53.2017 58.8361 51.5092 57.1664 51.5092 55.1141C51.5092 53.0618 53.2017 51.3921 55.282 51.3921C57.3624 51.3921 59.0549 53.0618 59.0549 55.1141C59.0549 57.1664 57.3624 58.8361 55.282 58.8361Z",
    fill: "url(#paint0_linear_1661_282)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1661_282",
    x1: 33,
    y1: -0.000488304,
    x2: 32.9982,
    y2: 63.9995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDA6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#070430"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFt04);
export default __webpack_public_path__ + "static/media/ft_04.c25dbfdd72638242ea276b91a47506e8.svg";
export { ForwardRef as ReactComponent };